import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { GetterTypes } from "@/store";
import { LayoutTypes } from "@/store/app/state";
import { getIsMobileLayoutDisplayed } from "@/utils/chat";
import { useComputedValue } from "@/composables";
import { computed } from "vue";
import MobileLayout from "@/components/layouts/MobileLayout.vue";
import MainLayout from "@/components/layouts/MainLayout.vue";
import ChatContainer from "@/components/chat/chatContainer/ChatContainer/ChatContainer.vue";
import NoChatContainer from "@/components/chat/chatContainer/NoChatContainer.vue";
import FullSizeImage from "@/components/images/FullSizeImage.vue";
import ChatSidebar from "@/components/chat/chatSidebar/ChatSidebar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Chat',
  setup(__props) {

const selectedChatId = useComputedValue<string | undefined>(
  GetterTypes.GET_SELECTED_CHAT_ID,
);

const accessToken = useComputedValue<string | undefined>(
  GetterTypes.GET_AUTH_ACCESS_TOKEN,
);
const layoutType = useComputedValue<LayoutTypes>(GetterTypes.GET_LAYOUT_TYPE);
const src = useComputedValue<string | undefined>(
  GetterTypes.GET_FULL_SIZE_IMAGE,
);
const isMobileLayoutDisplayed = computed(() => {
  return getIsMobileLayoutDisplayed(selectedChatId.value, layoutType.value);
});

return (_ctx: any,_cache: any) => {
  return (_unref(accessToken) || _unref(layoutType) === _unref(LayoutTypes).MOBILE)
    ? (_openBlock(), _createBlock(MainLayout, { key: 0 }, {
        default: _withCtx(() => [
          (isMobileLayoutDisplayed.value)
            ? (_openBlock(), _createBlock(MobileLayout, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(ChatSidebar)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(ChatContainer),
          (_unref(src))
            ? (_openBlock(), _createBlock(FullSizeImage, { key: 1 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : (_unref(layoutType) === _unref(LayoutTypes).DESKTOP)
      ? (_openBlock(), _createBlock(NoChatContainer, { key: 1 }))
      : _createCommentVNode("", true)
}
}

})